import { DateFilter } from './filters/date-filter.js';
import { SliderFilter } from './filters/slider-filter.js';
import { FeatureCheckboxFilter } from './filters/feature-checkbox-filter.js';
import { TypeCheckboxFilter } from './filters/type-checkbox-filter.js';
import { SortSelect } from './filters/sort-select.js';
import { AvailabilityFilter } from './filters/availability-filter.js';

export class FloorplanFilters {

    constructor() {

        this.hide_if_unavailable = hide_if_unavailable;

        this.selectedProperty = jQuery('.property').val();
        //this.selectedUnitType = jQuery('.floorplan-type').val();
        //this.checkedUnitType = [];

        this.api = jQuery('.mb-floorplans').data('api');

        //DOM elements to filter
        this.units = jQuery('.units .unit');
        this.floorplans = jQuery('.floorplan');

        // filter inputs
        this.datePicker = new DateFilter('.move-in-datepicker');
        this.priceSlider = new SliderFilter('.price-slider .range-slider', min_price, max_price, { decimals: 0, thousand: ',', prefix: '$' }, cur_min_price, cur_max_price);
        this.sqFootSlider = new SliderFilter('.sq-footage-slider .range-slider', min_sq_footage, max_sq_footage, { decimals: 0, thousand: ',' }, cur_min_sq_footage, cur_max_sq_footage);
        this.typeCheckbox = new TypeCheckboxFilter('.type-checkbox');
        this.featureCheckbox = new FeatureCheckboxFilter('.feature-checkbox');
        this.availableCheckbox = jQuery('#available-filter');
        this.sortSelect = new SortSelect('.mb-sort');
        this.availabilitySelect = new AvailabilityFilter('.availability-filter');

        // bind events to filter changes
        this.bindEvents();

        // do initial filtering
        if (jQuery('div').hasClass('mb-floorplans')) {
            this.typeCheckbox.updateValues();
            this.featureCheckbox.updateValues();
            this.filter();
            this.hideFloorplans();
            if (cur_sort !== '')
                this.sortSelect.sort();
        }

        //floorplans section is hidden until initialization is finished
        let Filters = this;
        //delay showing page so that everything has a change to initialize
        setTimeout(function () { Filters.showFloorplansPage(); }, 300);

    }

    bindEvents() {

        if (jQuery('.floorplans').hasClass('mb-floorplans')) {
            // filter floorplans when move in date value changes
            this.datePicker.dateInput.on('change', jQuery.proxy(this.dateHandler, this));

            // filter floorplans when price slider values change
            this.priceSlider.slider[0].noUiSlider.on('set', jQuery.proxy(this.priceHandler, this));

            // filter floorplans when sq footage slider values change
            this.sqFootSlider.slider[0].noUiSlider.on('set', jQuery.proxy(this.sqFootHandler, this));

            // filter floorplan types when type is clicked - Select Dropdown
            // if(this.typeSelect.length)
            // {
            //     this.typeSelect.on('change', this.typeSelectHandler);
            // }

            // filter floorplan types when type is clicked - Checkbox Box
            if (this.typeCheckbox.typeInput.length) {
                this.typeCheckbox.typeInput.on('change', jQuery.proxy(this.typeCheckHandler, this));
            }

            if (this.featureCheckbox.featureInput.length) {
                this.featureCheckbox.featureInput.on('change', jQuery.proxy(this.featureCheckHandler, this));

            }

            // Show Available Units Only Filter
            this.availableCheckbox.on('change', jQuery.proxy(this.availableCheckHandler, this));

            // AvailabilityFilter
            this.availabilitySelect.selectInput.on('change', jQuery.proxy(this.availabilitySelectHandler, this));

            // Sort Select
            this.sortSelect.selectInput.on('change', jQuery.proxy(this.sortSelectHandler, this))
        }
    }

    sortSelectHandler() {
        this.sortSelect.sort();
        this.updateUrlParams();
    }

    availabilitySelectHandler() {
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams();
    }

    typeSelectHandler() {
        //     this.selectedUnitType = this.value;
        //     this.filter();
        //     this.hideFloorplans();
    }

    typeCheckHandler() {
        this.typeCheckbox.updateValues();
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams();
    }

    availableCheckHandler() {
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams()
    }

    featureCheckHandler() {
        this.featureCheckbox.updateValues();
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams()
    }

    priceHandler() {
        this.priceSlider.updateValues();
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams();
    }

    sqFootHandler() {
        this.sqFootSlider.updateValues();
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams();
    }

    dateHandler() {
        this.filter();
        this.hideFloorplans();
        this.updateUrlParams();
    }

    filter() {

        let Filters = this;
        if (this.hide_if_unavailable) {
            this.units.each(function () {
                let unit = jQuery(this);
                // filter logic
                if (
                    Filters.filterByAvailable(unit) &&
                    Filters.filterByAvailability(unit) &&
                    Filters.filterByPrice(unit) &&
                    Filters.filterBySqFootage(unit) &&
                    Filters.filterByDate(unit) &&
                    Filters.filterByType(unit) &&
                    Filters.filterByFeature(unit)
                ) {
                    unit.addClass('show');
                    Filters.showElement(unit, 0);
                }
                else {
                    unit.removeClass('show');
                    Filters.hideElement(unit, 0);
                }

                Filters.updateApplyUrl(unit, 0);

            });
            this.updateCount();
        }
        else {
            this.floorplans.each(function () {
                let floorplan = jQuery(this);

                // filter logic
                if (
                    Filters.filterByAvailable(floorplan) &&
                    Filters.filterByAvailability(floorplan) &&
                    Filters.filterByPrice(floorplan) &&
                    Filters.filterBySqFootage(floorplan) &&
                    Filters.filterByType(floorplan) &&
                    Filters.filterByDate(floorplan) &&
                    Filters.filterByFeature(floorplan)) {
                    floorplan.addClass('show');
                    Filters.showElement(floorplan, 0);
                }
                else {
                    floorplan.removeClass('show');
                    Filters.hideElement(floorplan, 0);
                }
            });

        }

        this.alertIfNoneFound();
        this.disableWordpressModal();

        setTimeout(function () {
            jQuery('.scrollable').each(function () {
                if (jQuery(this).hasScrollBar()) {
                    jQuery(this).next().show(0);
                }
                else {
                    jQuery(this).next().hide(0);
                }
            });
        }, 500);
    }

    filterByType(asset) {
        return this.typeCheckbox.filter(asset);
    }

    filterByAvailability(asset) {
        return this.availabilitySelect.filter(asset);
    }

    filterByFeature(asset) {
        return this.featureCheckbox.filter(asset);
    }

    filterByPrice(asset) {
        return this.priceSlider.filter(asset, 'price');
    }

    filterByAvailable(asset) {
        if (jQuery('#available-filter').is(":checked")) {
            return asset.data('available')
        }
        else
            return true;
    }

    filterBySqFootage(asset) {
        return this.sqFootSlider.filter(asset, 'sq-footage');
    }

    filterByDate(asset) {
        return this.datePicker.filter(asset);
    }

    hideFloorplans() {
        let Filters = this;

        this.floorplans.each(function () {
            if (jQuery(this).hasClass('show')) {
                Filters.showElement(jQuery(this), 0);
            }
            else {
                Filters.hideElement(jQuery(this), 0);
            }
        });

    }

    updateCount() {
        this.floorplans.each(function () {
            var count = 0;

            count = jQuery(this).find('.unit.show').length;

            if (jQuery('.floorplans').hasClass('full-cards-template')) {
                var visibleCount = 0;
                visibleCount = jQuery(this).children('.units').children('.unit.show').length;
                var hiddenCount = parseInt(count) - parseInt(visibleCount);
                jQuery(this).find('.dynamic.count').text(hiddenCount);
                jQuery('.search-number').html(jQuery('.card.show').length);

                hiddenCount < 1 ? jQuery(this).find('.open-drawer').hide() : jQuery(this).find('.open-drawer').show();
            }
            else {
                jQuery(this).find('.dynamic.count').text(count);
                //
            }

            if (count == 0) {
                jQuery(this).removeClass('show');
            }
            else {
                jQuery(this).addClass('show');
            }
        });

        jQuery('.search-number').html(jQuery('.card.show').length);
    }

    getCount(floorplan) {
        return parseInt(floorplan.find('.dynamic.count').text());
    }

    showFloorplansPage() {
        jQuery('.mb-floorplans').css('opacity', '1');
    }

    alertIfNoneFound() {
        if (jQuery('.floorplan.show').length == 0) {
            this.showElement(jQuery('.none-found'), 1);
        }
        else {
            this.hideElement(jQuery('.none-found'), 0);
        }
    }

    showElement(element, speed) {
        speed = speed ? speed : 500;
        element.show(0);
    }

    hideElement(element, speed) {
        speed = speed ? speed : 500;
        element.hide(0);
    }

    updateApplyUrl(unit) {
        var link = unit.find('.apply a').attr('href');
        var date = this.datePicker.getValue();

        //replace all entrata move in dates
        var regex = /lease_start_date=(\d{2}\/\d{2}\/\d{4})?/;
        link = link.replace(regex, 'lease_start_date=' + date);

        //replace all realpage move in dates
        regex = /MoveInDate=(\d{2}\/\d{2}\/\d{4})?/;
        link = link.replace(regex, '/MoveInDate=' + date);


        unit.find('.apply a').attr("href", link);
    }

    disableWordpressModal() {
        if (jQuery('.mb-floorplans').data('api') === 'wordpress') {
            jQuery('.button').each(function () {
                if (jQuery(this).attr('data-modal-target')) {
                    jQuery(this).addClass('disabled');
                }
            });
        }
    }

    updateUrlParams() {
        var types = this.typeCheckbox.getValues();
        var features = this.featureCheckbox.getValues();
        var url = new URL(window.location.origin + window.location.pathname);
        var sort = jQuery(this.sortSelect.selectInput).val();
        var availability = parseInt(jQuery(this.availabilitySelect.selectInput).val());

        // show available
        if (!jQuery('#available-filter').is(":checked")) {
            url.searchParams.append("available", "0");
        }

        // unit type
        types.forEach(element => {
            if (element != null) {
                url.searchParams.append("type-filter-" + element, "1");
            }
        });

        // unit features
        features.forEach(element => {
            if (element != null) {
                url.searchParams.append("feature-filter-" + element, "1");
            }
        });

        // price range
        if (parseFloat(this.priceSlider.lowValue) !== parseFloat(min_price)) {
            url.searchParams.append("min-price", this.priceSlider.lowValue);
        }
        if (parseFloat(this.priceSlider.highValue) !== parseFloat(max_price)) {
            url.searchParams.append("max-price", this.priceSlider.highValue);
        }

        // sq footage range
        if (parseFloat(this.sqFootSlider.lowValue) !== parseFloat(min_sq_footage)) {
            url.searchParams.append("min-sq", this.sqFootSlider.lowValue);
        }
        if (parseFloat(this.sqFootSlider.highValue) !== parseFloat(max_sq_footage)) {
            url.searchParams.append("max-sq", this.sqFootSlider.highValue);
        }

        // availability
        if (!isNaN(availability)) {
            if (availability !== '') {
                url.searchParams.append("availability", availability);
            }
        }

        // sort
        if (sort !== null) {
            if (sort !== '') {
                url.searchParams.append("sort", sort);
            }
        }

        // push url address
        history.pushState('', '', url.href);
    }
};
